import { Typography } from "@mui/material";
import { EmailModalDescriptionWarning } from "./warning";

export interface IEmailModalDescriptionProps {
  candidatesCount: number;
  eligibleCandidatesCount: number;
}

export const EmailModalDescription = ({ candidatesCount, eligibleCandidatesCount }: IEmailModalDescriptionProps) => {
  if (candidatesCount === eligibleCandidatesCount) {
    return (
      <Typography variant="body1">
        Vous avez sélectionné{" "}
        {candidatesCount > 1 ? `${candidatesCount} candidats afin de leur` : "un candidat afin de lui"} envoyer un
        email. Vous pouvez sélectionner un modèle type ci dessous ou envoyer un email libre.
      </Typography>
    );
  }
  return (
    <>
      <EmailModalDescriptionWarning
        candidatesCount={candidatesCount}
        eligibleCandidatesCount={eligibleCandidatesCount}
      />
      <Typography variant="body1">
        Vous pouvez sélectionner un modèle type ci dessous ou envoyer un email libre.
      </Typography>
    </>
  );
};
